export const getPatterns = (field: string) => {
  if (field) {
    switch (field) {
      case 'firstName':
        return {
          value: /^[a-zA-Z'-.\s]{2,20}$/,
          message: 'Please enter a valid first name.',
        };
      case 'lastName':
        return {
          value: /^[a-zA-Z'-.\s]{2,20}$/,
          message: 'Please enter a valid last name.',
        };
      case 'email':
        return {
          value: /[a-z0-9.]{1,30}\S.\S[a-zA-Z0-9.]{1,20}\S.[a-z]{2,4}$/i,
          message: 'Please enter a valid email address.',
        };
      case 'phone':
        return {
          value: /^\d{3}-\d{3}-\d{4}/g,
          message: 'Please enter a valid phone number.',
        };
      case 'address':
        return {
          value: /^[a-zA-Z0-9'-.\s]{5,30}$/,
          message: 'Please enter a valid street address.',
        };
      case 'city':
        return {
          value: /^[a-zA-Z'-.\s]{2,25}$/,
          message: 'Please enter a valid city.',
        };
      case 'state':
        return {
          value: /^[a-zA-Z]{2}$/,
          message: 'Please select a state.',
        };
      case 'zip':
        return {
          value: /^[0-9]{5}$/,
          message: 'Please enter a valid zip code.',
        };
      case 'yearPurchased': {
        const currentYear = new Date().getFullYear();
        return {
          value: new RegExp(`^(19[0-9]{2}|20[0-${Math.floor(currentYear % 10)}]{1}[0-9])$`),
          message: `Please enter a valid year between 1900 and ${currentYear}.`,
        };
      }
      case 'comments': {
        return {
          value: /^[a-zA-Z0-9'-.@;?\s]{0,500}$/,
          message: 'Please remove any special characters.',
        };
      }
      default:
        return {
          value: /^[a-zA-Z0-9'-.\s]{20}$/,
          message: 'Please enter a valid entry.',
        };
    }
  }
};

export const getMinValues = (field: string) => {
  if (field) {
    switch (field) {
      case 'firstName':
        return {
          value: 2,
          message: 'Please enter at least 2.',
        };
      case 'lastName':
        return {
          value: 2,
          message: 'Please enter at least 2.',
        };
      case 'email':
        return {
          value: 2,
          message: 'Please enter at least 2 characters.',
        };
      case 'phone':
        return {
          value: 8,
          message: 'Please enter a valid phone number.',
        };
      case 'address':
        return {
          value: 5,
          message: 'Please enter at least 5 characters.',
        };
      case 'city':
        return {
          value: 2,
          message: 'Please enter at least 2 characters.',
        };
      case 'state':
        return {
          value: 2,
          message: 'Please select a state.',
        };
      case 'zip':
        return {
          value: 5,
          message: 'Please enter a 5 digit zip code.',
        };
      default:
        return {
          value: 2,
          message: 'Please enter a valid entry.',
        };
    }
  }
};

export const getMaxValues = (field: string) => {
  if (field) {
    switch (field) {
      case 'firstName':
        return {
          value: 20,
          message: 'Please enter no more than 20 characters.',
        };
      case 'lastName':
        return {
          value: 20,
          message: 'Please enter no more than 20 characters.',
        };
      case 'email':
        return {
          value: 75,
          message: 'Please enter a valid email address.',
        };
      case 'phone':
        return {
          value: 14,
          message: 'Please enter a valid phone number.',
        };
      case 'address':
        return {
          value: 30,
          message: 'Please enter no more than 30 characters.',
        };
      case 'city':
        return {
          value: 25,
          message: 'Please enter no more than 25 characters.',
        };
      case 'state':
        return {
          value: 2,
          message: 'Please select a state.',
        };
      case 'zip':
        return {
          value: 5,
          message: 'Please enter a 5 digit zip code.',
        };
      case 'comments': {
        return {
          value: 500,
          message: 'Please enter no more than 500 characters.',
        };
      }
      default:
        return {
          value: 20,
          message: 'Please enter a valid entry.',
        };
    }
  }
};

export const inquiryOptions = [
  {
    name: 'Clayton Manufacturing',
    value: 'clayton-manufacturing',
  },
  {
    name: 'Clayton Properties Group',
    value: 'clayton-properties-group',
  },
  {
    name: 'Clayton Supply',
    value: 'clayton-supply',
  },
  {
    name: 'General Question',
    value: 'general',
  },
];

/* Only establishing Contiguous States */
export const stateOptions = [
  { name: 'Alabama', abbreviation: 'AL' },
  { name: 'Arizona', abbreviation: 'AZ' },
  { name: 'Arkansas', abbreviation: 'AR' },
  { name: 'California', abbreviation: 'CA' },
  { name: 'Colorado', abbreviation: 'CO' },
  { name: 'Connecticut', abbreviation: 'CT' },
  { name: 'Delaware', abbreviation: 'DE' },
  { name: 'Florida', abbreviation: 'FL' },
  { name: 'Georgia', abbreviation: 'GA' },
  { name: 'Idaho', abbreviation: 'ID' },
  { name: 'Illinois', abbreviation: 'IL' },
  { name: 'Indiana', abbreviation: 'IN' },
  { name: 'Iowa', abbreviation: 'IA' },
  { name: 'Kansas', abbreviation: 'KS' },
  { name: 'Kentucky', abbreviation: 'KY' },
  { name: 'Louisiana', abbreviation: 'LA' },
  { name: 'Maine', abbreviation: 'ME' },
  { name: 'Maryland', abbreviation: 'MD' },
  { name: 'Massachusetts', abbreviation: 'MA' },
  { name: 'Michigan', abbreviation: 'MI' },
  { name: 'Minnesota', abbreviation: 'MN' },
  { name: 'Mississippi', abbreviation: 'MS' },
  { name: 'Missouri', abbreviation: 'MO' },
  { name: 'Montana', abbreviation: 'MT' },
  { name: 'Nebraska', abbreviation: 'NE' },
  { name: 'Nevada', abbreviation: 'NV' },
  { name: 'New Hampshire', abbreviation: 'NH' },
  { name: 'New Jersey', abbreviation: 'NJ' },
  { name: 'New Mexico', abbreviation: 'NM' },
  { name: 'New York', abbreviation: 'NY' },
  { name: 'North Carolina', abbreviation: 'NC' },
  { name: 'North Dakota', abbreviation: 'ND' },
  { name: 'Ohio', abbreviation: 'OH' },
  { name: 'Oklahoma', abbreviation: 'OK' },
  { name: 'Oregon', abbreviation: 'OR' },
  { name: 'Pennsylvania', abbreviation: 'PA' },
  { name: 'Rhode Island', abbreviation: 'RI' },
  { name: 'South Carolina', abbreviation: 'SC' },
  { name: 'South Dakota', abbreviation: 'SD' },
  { name: 'Tennessee', abbreviation: 'TN' },
  { name: 'Texas', abbreviation: 'TX' },
  { name: 'Utah', abbreviation: 'UT' },
  { name: 'Vermont', abbreviation: 'VT' },
  { name: 'Virginia', abbreviation: 'VA' },
  { name: 'Washington', abbreviation: 'WA' },
  { name: 'West Virginia', abbreviation: 'WV' },
  { name: 'Wisconsin', abbreviation: 'WI' },
  { name: 'Wyoming', abbreviation: 'WY' },
];
